<div class="contenedor"> 

  <div class="flex-row"> 
    <div class="tittle text-align-center"> 
      {{ 'urgency.claimDeclaration' | translate }}
    </div>
  </div>


  <div class="flex-row"> 
    <div class="tittle-2 text-align-center"> 
      {{ 'urgency.selectEvent' | translate }}
    </div>
  </div>
  <div class="flex-row options-border margin-5 text-align-start"> 
    <button type="button" class="btn btn-lg" (click)="activeModal.close('Option1')">{{ 'urgency.noAccessHome' | translate }}</button>
  </div>
  <div class="flex-row options-border margin-5 text-align-start"> 
    <button type="button" class="btn btn-lg" (click)="activeModal.close('Option2')">{{ 'urgency.faucetWater' | translate }}</button>
  </div>
  <div class="flex-row options-border margin-5 text-align-start"> 
    <button type="button" class="btn btn-lg" (click)="activeModal.close('Option3')">{{ 'urgency.noLight' | translate }}</button>
  </div>
  <div class="flex-row options-border margin-5 text-align-start"> 
    <button type="button" class="btn btn-lg" (click)="activeModal.close('Option4')">{{ 'urgency.otherProblem' | translate }}</button>
  </div>
</div>


